/* tslint:disable */
/* eslint-disable */
/**
 * Melco Tracking APIs
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    TrackingMelcoModelsCustomWarning,
    TrackingMelcoModelsCustomWarningFromJSON,
    TrackingMelcoModelsCustomWarningFromJSONTyped,
    TrackingMelcoModelsCustomWarningToJSON,
    TrackingTrackingModelsAnalyticsDownloadDailySummary,
    TrackingTrackingModelsAnalyticsDownloadDailySummaryFromJSON,
    TrackingTrackingModelsAnalyticsDownloadDailySummaryFromJSONTyped,
    TrackingTrackingModelsAnalyticsDownloadDailySummaryToJSON,
} from './';

/**
 * 
 * @export
 * @interface TrackingMelcoModelsGenericList1TrackingModelsAnalyticsDownloadDailySummary
 */
export interface TrackingMelcoModelsGenericList1TrackingModelsAnalyticsDownloadDailySummary {
    /**
     * 
     * @type {Array<TrackingTrackingModelsAnalyticsDownloadDailySummary>}
     * @memberof TrackingMelcoModelsGenericList1TrackingModelsAnalyticsDownloadDailySummary
     */
    list: Array<TrackingTrackingModelsAnalyticsDownloadDailySummary>;
    /**
     * 
     * @type {Array<TrackingMelcoModelsCustomWarning>}
     * @memberof TrackingMelcoModelsGenericList1TrackingModelsAnalyticsDownloadDailySummary
     */
    warning_list?: Array<TrackingMelcoModelsCustomWarning> | null;
    /**
     * 
     * @type {number}
     * @memberof TrackingMelcoModelsGenericList1TrackingModelsAnalyticsDownloadDailySummary
     */
    total: number;
}

export function TrackingMelcoModelsGenericList1TrackingModelsAnalyticsDownloadDailySummaryFromJSON(json: any): TrackingMelcoModelsGenericList1TrackingModelsAnalyticsDownloadDailySummary {
    return TrackingMelcoModelsGenericList1TrackingModelsAnalyticsDownloadDailySummaryFromJSONTyped(json, false);
}

export function TrackingMelcoModelsGenericList1TrackingModelsAnalyticsDownloadDailySummaryFromJSONTyped(json: any, ignoreDiscriminator: boolean): TrackingMelcoModelsGenericList1TrackingModelsAnalyticsDownloadDailySummary {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'list': ((json['list'] as Array<any>).map(TrackingTrackingModelsAnalyticsDownloadDailySummaryFromJSON)),
        'warning_list': !exists(json, 'warning_list') ? undefined : (json['warning_list'] === null ? null : (json['warning_list'] as Array<any>).map(TrackingMelcoModelsCustomWarningFromJSON)),
        'total': json['total'],
    };
}

export function TrackingMelcoModelsGenericList1TrackingModelsAnalyticsDownloadDailySummaryToJSON(value?: TrackingMelcoModelsGenericList1TrackingModelsAnalyticsDownloadDailySummary | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'list': ((value.list as Array<any>).map(TrackingTrackingModelsAnalyticsDownloadDailySummaryToJSON)),
        'warning_list': value.warning_list === undefined ? undefined : (value.warning_list === null ? null : (value.warning_list as Array<any>).map(TrackingMelcoModelsCustomWarningToJSON)),
        'total': value.total,
    };
}


